// assets
import { IconCoin } from '@tabler/icons';
import CoinAoneDark from '../assets/images/CoinAoneDark';
import SummarizeIcon from '@mui/icons-material/Summarize';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import SubdirectoryArrowLeftIcon from '@mui/icons-material/SubdirectoryArrowLeft';
import { IconMessage } from '@tabler/icons';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import PhonelinkLockIcon from '@mui/icons-material/PhonelinkLock';
import PhonelinkSetupIcon from '@mui/icons-material/PhonelinkSetup';
import EditNoteIcon from '@mui/icons-material/EditNote';
// constant
const icons = {
    PhonelinkLockIcon,
    PhonelinkSetupIcon,
    EditNoteIcon,
    IconCoin,
    CoinAoneDark,
    SummarizeIcon,
    CardGiftcardIcon,
    CampaignIcon,
    CreditCardIcon,
    SubdirectoryArrowLeftIcon,
    IconMessage,
    CloudUploadIcon,
    DescriptionIcon
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

function children() {
    const children = [];
    if (localStorage.getItem('role')) {
        const Roles = localStorage.getItem('role').split(',');
        if (Roles.includes('61')) {
            children.push({
                id: 'changerequestapproval',
                title: 'Change Request',
                type: 'item',
                url: '/admin/changerequest',
                target: false,
                icon: icons.IconMessage
            });
        }

        if (Roles.includes('99')) {
            children.push({
                id: 'sftpupload',
                title: 'Upload File → Samsung',
                caption: 'Manual SFTP upload',
                type: 'item',
                url: '/admin/sftpupload',
                target: false,
                icon: icons.CloudUploadIcon
            });
            children.push({
                id: 'reporttexts',
                title: 'Samsung Report Texts',
                caption: 'History + Resend',
                type: 'item',
                url: '/admin/reporttexts',
                target: false,
                icon: icons.DescriptionIcon
            });
            // Loan System — device control. Commanding a handset still needs role 66, since
            // roleCheck resolves a single role per (baseUrl, method) on /api/loanapproval.
            children.push({
                id: 'loanknox',
                title: 'Loan System — Knox Guard',
                caption: 'Lock / unlock · licence · devices',
                type: 'item',
                url: '/admin/loan/knox',
                target: false,
                icon: icons.PhonelinkLockIcon
            });
            // Its own entry rather than a tab on the dashboard: this gets opened with an IMEI
            // in hand before a contract is issued, which is a different moment from reviewing
            // the tenant.
            children.push({
                id: 'loanknoximei',
                title: 'Knox — ກວດ IMEI',
                caption: 'IMEI check · free, no seat',
                type: 'item',
                url: '/admin/loan/knox/imei',
                target: false,
                icon: icons.PhonelinkSetupIcon
            });
            // Correcting a loan by hand. Admin-only and kept away from the Finance menus on
            // purpose: it moves a balance with no payment behind it, and the person who asks
            // for that should not be the person who does it.
            children.push({
                id: 'loanadjust',
                title: 'Loan System — ແກ້ໄຂງວດ',
                caption: 'Adjust instalments · penalties · paid date',
                type: 'item',
                url: '/admin/loan/adjust',
                target: false,
                icon: icons.EditNoteIcon
            });
        }

        // if (Roles.includes('61')) {
        //     children.push({
        //         id: 'aonewallet',
        //         title: 'Aone Wallet Controller',
        //         type: 'item',
        //         url: '/financial/aonewallet',
        //         target: false,
        //         icon: icons.CoinAoneDark
        //     });
        //     children.push({
        //         id: 'aonewalletHistory',
        //         title: 'AoneWallet History',
        //         type: 'item',
        //         url: '/financial/aonewallet/history',
        //         target: false,
        //         icon: icons.SummarizeIcon
        //     });
        //     children.push({
        //         id: 'aonewalletHistory',
        //         title: 'Credit Requirement',
        //         type: 'item',
        //         url: '/financial/aonewallet/credit',
        //         target: false,
        //         icon: icons.CardGiftcardIcon
        //     });
        // }
    }
    return children;
}
const approval = {
    id: 'admin',
    title: 'Admin',
    type: 'group',
    children: children()
};

export default approval;
